export default __webpack_public_path__ + "static/media/error.3fb5ef93.mp3";